import React from 'react'
import styles from './serviceDetailSec.module.css'
import { serviceAr } from '../../../assets'
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';

const WorkDetailServiceList = ({ workData }) => {
    const { t, i18n } = useTranslation();
    return (
        <div className={styles.ServiceDetailServiceList}>
            <div className={styles.ServiceDetailServiceListInner}>


                <div className={styles.ServiceDetailServiceListInnerLft}>
                    <div className={`${styles.WorkDetailDisc_innerTitle} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>
                        {/* <h3>DESTINATION ABU DHABI</h3> */}
                        {/*  <h3>{workData?.title}</h3> */}
                        <h3>{t('industry')}</h3>
                    </div>
                    <div className={`${styles.ServiceDetailServiceListSec} ${i18n.language === LANG_AR ? "arab" : ''} `}>
                        <div className={styles.ServiceDetailServiceListSecD}>
                            {/*  <h3>{service.feature}</h3> */}

                            <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? workData?.category?.category : workData?.category?.categoryAr }}></p>
                            {/* <p>test</p> */}
                        </div>
                    </div>


                    <div className={`${styles.WorkDetailDisc_innerTitle} ${i18n.language === LANG_AR ? 'arabText' : ''} scope`}>
                        {/* <h3>DESTINATION ABU DHABI</h3> */}
                        {/*  <h3>{workData?.title}</h3> */}
                        {/* <h1>Scope</h1> */}
                        <h3>{t('scope')}</h3>
                    </div>
                    <div className={`${styles.ServiceDetailServiceListSec} ${i18n.language === LANG_AR ? "arab" : ''} `}>
                        <div className={styles.ServiceDetailServiceListSecD}>
                            {/*  <h3>{service.feature}</h3> */}

                            <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? workData?.scope : workData?.scopeAr }}></p>
                            {/* <p>test</p> */}
                        </div>
                    </div>

                </div>
                <div className={styles.ServiceDetailServiceListInnerRgt}>
                    <div className={`${styles.WorkDetailDisc_innerTitle} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>
                        {/* <h3>DESTINATION ABU DHABI</h3> */}
                        {/*  <h3>{workData?.title}</h3> */}
                        <h3>{i18n.language === LANG_EN ? workData?.title : workData?.titleAr}</h3>
                    </div>

                    <div className={`${styles.ServiceDetailServiceListSec} ${i18n.language === LANG_AR ? "arab" : ''} `}>
                        <div className={styles.ServiceDetailServiceListSecD}>
                            {/*  <h3>{service.feature}</h3> */}

                            <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? workData?.description : workData?.descriptionAr }}></p>
                            {/* <p>test</p> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkDetailServiceList
